<template>
  <div class="wg-col wg-xs-12" style="padding: 2%">
    <wg-modal
      v-if="openModal"
      :width="windowWidth > 700 ? '500px' : '80%'"
      :portal="true"
      @closeModal="closeModal"
    >
      <div slot="header" class="com-anm22-app-text-xl">
        <span>{{
          mode == "edit"
            ? $anm22.strLang(lang, "Movement #" + currentMovement.idWarehouseMovement, "Movimento #" + currentMovement.idWarehouseMovement)
            : $anm22.strLang(lang, "New", "Nuovo")
        }}</span>
      </div>

      <div slot="body">
        <span>{{ $anm22.strLang(lang, "Date", "Data") }}</span>
        <div class="wg-col wg-xs-5">
          <input
            class="input-elem print-elem com-anm22-app-input-text"
            type="text"
            :value="$moment.unix(currentMovement.ts).format('DD-MM-YYYY HH:mm')"
            disabled
          />
          <div class="vertical-height-div" style="height: 12px"></div>
        </div>
        <span>{{ $anm22.strLang(lang, "Movement code", "Codice movimento") }}</span>
        <div class="wg-col wg-xs-5">
          <input
            class="input-elem print-elem com-anm22-app-input-text"
            type="text"
            v-model="currentMovement.code"
            disabled
          />
          <div class="vertical-height-div" style="height: 12px"></div>
        </div>
        <span style="font-weight:bold">{{ $anm22.strLang(lang, "Items", "Articoli") }}</span>
        <div class="movement-items-list" v-if="currentMovement.items">
          <div
            class="wg-row movement-item-row header"
          >
            <div class="quantity">{{ $anm22.strLang(lang, 'Qnt', 'Qnt') }}</div>
            <div class="code">{{ $anm22.strLang(lang, 'Code', 'Codice') }}</div>
            <div class="name">{{ $anm22.strLang(lang, 'Name', 'Nome') }}</div>
          </div>
          <div
            class="wg-row movement-item-row"
            v-for="(movementItem, index) in currentMovement.items"
            :key="index"
          >
            <div class="quantity">{{ movementItem.variation }}</div>
            <div class="code">{{ movementItem.productCode }}</div>
            <div class="name">{{ movementItem.productName }}</div>
          </div>
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <div v-if="false" class="wg-row">
          <input type="button" :value="$anm22.strLang(lang, 'Save', 'Salva')" @click="addMovement" />
        </div>
      </div>
    </wg-modal>
    <div style="font-size: 24px" class="com-anm22-app-text-m">
      {{ $anm22.strLang(lang, "Movements", "Movimenti") }}
    </div>
    <div class="vertical-height-div" style="height: 20px"></div>
    <div v-if="false" class="wg-row">
      <input
        type="button"
        :value="$anm22.strLang(lang, 'Add movement', 'Aggiungi movimento')"
        @click="add"
      />
    </div>
    <div class="vertical-height-div" style="height: 20px"></div>
    <div class="movements-list">
      <div
        class="wg-row movement-row header"
      >
        <div class="id">Id</div>
        <div class="date">{{ $anm22.strLang(lang, 'Date', 'Data') }}</div>
        <div class="code">{{ $anm22.strLang(lang, 'Code', 'Codice') }}</div>
      </div>
      <div
        class="wg-row movement-row"
        v-for="(movement, index) in movements"
        :key="index"
        @click="selectMovement(movement)"
      >
        <div class="id">{{ movement.idWarehouseMovement }}</div>
        <div class="date">{{ $moment.unix(movement.ts).format('DD-MM-YYYY HH:mm') }}</div>
        <div class="code">{{ movement.code }}</div>
        <div class="edit" v-if="false"><img :src="$anm22.icons.getWorldIcon('edit')" class="edit-btn" :title="$anm22.strLang(lang, 'Edit', 'Modifica')" @click="selectMovement(movement)" /></div>
        <div class="delete" v-if="false"><img :src="$anm22.icons.getWorldIcon('deleteBin')" class="delete-btn" :title="$anm22.strLang(lang, 'Delete', 'Elimina')" @click="removeMovement(movement)" /></div>
      </div>
      <div
        class="empty-list-msg"
        v-if="!movements || movements.length == 0"
      >
        {{ $anm22.strLang(lang, 'No movements.', 'Nessun movimento.') }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      movements: [],
      mode: "edit",
      openModal: false,
      currentMovement: {},
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      windowWidth: (state) => state.windowWidth,
    }),
  },
  methods: {
    loadData() {
      this.$http
        .get("warehouse-movements")
        .then((response) => {
          this.movements = response.data.movements;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    add() {
      this.currentMovement = {};
      this.openModal = true;
      this.mode = "new";
    },
    getMovement(movementId) {
      this.$http
        .get("warehouse-movement/" + movementId)
        .then((response) => {
          this.currentMovement = response.data.movement;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addMovement() {
      if (this.mode == 'new') {
        this.$http
          .post(
            "warehouse-movement/new",
            {
              movement: this.currentMovement,
            },
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            this.$anm22.eventBus.$emit("wg-modal-close");
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$http
          .post(
            "warehouse-movement/edit",
            {
              movement: this.currentMovement,
            },
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            this.loadData();
            this.$anm22.eventBus.$emit("wg-modal-close");
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    removeMovement(movement) {
      this.$http
        .post(
          "warehouse-movement/delete",
          {
            movement: movement,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.loadData();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    selectMovement(movement) {
      this.mode = "edit";
      this.currentMovement = movement;
      this.$http
        .get("warehouse-movement?idMovement=" + movement.idWarehouseMovement)
        .then((response) => {
          this.currentMovement = response.data.movement;
          this.openModal = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    closeModal() {
      this.loadData();
      this.openModal = false;
    },
  },
  created() {
    this.loadData();
  },
};
</script>

<style lang="scss" scoped>
  .movements-list {
    overflow-x: auto;

    .movement-row {
      border-radius: 8px;
      min-height: 49px;
      padding: 5px;
      flex-wrap: nowrap;
      cursor: pointer;

      &:hover {
        background-color: #ffffff;
      }
      div {
        display: inline-block;
        vertical-align: top;
        white-space: normal;
        padding:11px;
        
        &.id {
          width:20%;
          min-width: 60px;
        }
        &.date {
          width:calc(60% - 72px);
          min-width: 120px;
        }
        &.code {
          width:20%;
          min-width: 60px;
        }
        &.edit,
        &.delete {
          padding: 8px;
          
          .edit-btn,
          .delete-btn {
            width: 20px;
            height: 20px;
            cursor: pointer;
          }
        }
      }

      &.header {
        div {
          font-weight: 600;
        }

        &:hover {
          background: none !important;
        }
      }
    }

    .empty-list-msg {
      padding: 16px;
    }
  }

  .movement-items-list {
    .movement-item-row {
      border-radius: 8px;
      min-height: 49px;
      padding: 5px;
      flex-wrap: nowrap;

      &:hover {
        background-color: #ffffff;
      }
      div {
        display: inline-block;
        vertical-align: top;
        white-space: normal;
        padding:11px;

        &.code {
          width:30%;
        }
        &.name {
          width:50%;
        }
        &.quantity {
          width:20%;
        }
      }

      &.header {
        div {
          font-weight: 600;
        }
      }
    }
  }
</style>
